<template>
    <div class="field">
        <label class="label">Chassis numbers</label>
        <div class="control">
            <multi-select v-model="chassis"
                          :close-on-select="false"
                          :options="existingChassis"
                          :multiple="true"
                          placeholder="Type chassis"
                          :taggable="true"
                          @tag="addChassis"
                          @remove="removeChassis">
            </multi-select>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect';
    export default {
        components: {
            MultiSelect
        },
        data () {
            return {
                existingChassis: []
            }
        },
        computed: {
            chassis: {
                get: function () {
                    return this.$store.getters.getQueryChassis
                },
                set: function () {
                    
                }
            }
        },
        methods: {
            addChassis(value) {
                this.$store.dispatch('handleQueryChassis', value)
            },
            removeChassis(value) {
                this.$store.dispatch('removeChassisFromQuery', value)
            }
        }
    }
</script>


<style scoped>
    .field {
        margin-top: 10px;
    }

    input:focus {
        outline:none;
    }
    .tags-input input{
        height: 100% !important;
        width: 250px !important;
        border-style: none !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Auctions/Specification/ChassisInput.vue